import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {

    /**************************************************************
    -> Animate sticky when the right section is in the viewport
    **************************************************************/
    function fadeImages() {
      const images = Array.from(document.querySelectorAll('[data-image-id]'))
      const triggers = Array.from(document.querySelectorAll('[data-image-trigger]'))
      
      triggers.forEach(trigger => {
        const id = trigger.dataset.imageTrigger

        if (id) {
          const thisImage = document.querySelector(`[data-image-id="${id}"]`)
          const filteredImages = images.filter(image => image.dataset.imageId !== id)

          ScrollTrigger.matchMedia({
            // desktop
            '(min-width: 768px)': function() {
              ScrollTrigger.create({
                trigger: trigger,
                start: 'top bottom',
                end: 'bottom top',
                onEnter: () => {
                  gsap.to(filteredImages, {duration: 0.3, opacity: 0, zIndex: 0})
                  gsap.to(thisImage, {duration: 0.3, opacity: 1, zIndex: 10})
                },
                onEnterBack: () => {
                  gsap.to(filteredImages, {duration: 0.3, opacity: 0, zIndex: 0})
                  gsap.to(thisImage, {duration: 0.3, opacity: 1, zIndex: 10})
                },
              });
            },
          })
        }

      })    
    }

    fadeImages()

    /**************************************************************
    -> Only show expand buttons once the header is scrolled past
    **************************************************************/
    function showExpandIcons() {
      const header = document.querySelector('.banner')
      const triggers = Array.from(document.querySelectorAll('.expand'))

          ScrollTrigger.matchMedia({
            // desktop
            '(min-width: 768px)': function() {
              ScrollTrigger.create({
                trigger: header,
                start: 'top top',
                end: 'bottom+=100 top',
                onLeave: () => {
                  gsap.to(triggers, {duration: 0.3, opacity: 1})
                },
                onEnterBack: () => {
                  gsap.to(triggers, {duration: 0.3, opacity: 0})
                },
              });
            },
          })
        
    }

    showExpandIcons()

    /**************************************************************
    -> Launch image lightbox when expand button is clicked
    **************************************************************/
    function imageLightboxes() {

      const buttons = Array.from(document.querySelectorAll('[data-button-expand]'))
    
      if (buttons) {
    
        buttons.forEach(button => {
          const id = button.dataset.buttonId
          const lightbox = document.querySelector(`[data-lightbox-image][data-index="${id}"]`)
          const close = lightbox.querySelector('[data-button-contract]')
          
          button.addEventListener('click', () => {
            document.body.style.overflow = 'hidden'
            gsap.to(lightbox, { opacity: 1, pointerEvents: 'all'})
          })
          
          close.addEventListener('click', () => {
            document.body.style.overflow = 'initial'
            gsap.to(lightbox, { opacity: 0, pointerEvents: 'none'})
          })
    
        });
    
      }
    
    }

    imageLightboxes()

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/single-tours.js